<template>
  <div class="container">
      <div class="title0">
        <router-link :to="{path:'/'}"><img src="../assets/img/xaiofei/sy.png" class="return" /></router-link>
        <img src="../assets/img/xaiofei/fh.png" class="return" @click="clickReturn" />
        <img src="../assets/img/zhibo/gx.png" class="guang1" />
        <img src="../assets/img/zhibo/gx.png" class="guang2" />
      </div>
      <div class="content">
        <!-- 左侧导航 -->
        <div class="navBox">
          <div class="navLeft  animate__animated animate__fadeInLeft" :class="isShow? '' : 'left1'">
            <div :class="isShow? 'leftLeft' : 'leftLeft1'">
              <router-link :to="{path:'/xiaofei'}"><div class="btn btn1" ><span>电商直播</span></div></router-link>
              <router-link :to="{path:'/xiaofeiData'}"><div class="btn btn2"><span>电商大数据</span></div></router-link>
             <router-link :to="{path:'/xiaofeiChanpin'}"> <div class="btn btn2"><span>电商产品</span></div></router-link>
             <router-link :to="{path:'/zhibo'}"> <div class="btn btn2"><span>电商直播看板</span></div></router-link>
            </div>
            <img src="../assets/img/xaiofei/jt.png" class="jiantou" :class="!isShow?'jiantou1':''" @click="close" />
          </div>
        </div>
        <router-view :key="$route.fullPath"></router-view>
        <!-- 左侧 -->
        <div class="leftBox"></div> 
         <!--中间地图  -->
        <div class="center">
          <!-- <div class="centerBg1"></div>
          <div class="map"><img src="../assets/img/xaiofei/map.png" /></div> -->
          <centerRadar/>
          <!-- <Map /> -->
        </div>
        <!-- 右侧 -->
        <div class="right">
          <div class="boxRight" >
            <div class="title">直播平台</div>
            <div class="boxContent1">
              <div class="boxContent1Left">
                <div v-for="(item,index) in zhibo" :key="index" class="boxContent1LeftItem  animate__animated animate__zoomIn">
                  <div class="name"><img :src="item.icon" /><span>{{item.name}}</span></div>
                  <div class="value">{{item.value}}</div>
                </div>
              </div>
              <div  ref="canvasContainer" class="boxContent1Right"></div>
            </div>
          </div>
          <div class="boxRight">
            <div class="title">在线人气</div>
            <div class="boxContent2">
              <div class="rightLine"><RightLine /></div>
              <div class="leftContent animate__animated animate__slideInLeft">
                <h4>2024年度</h4>
                <div class="list">
                  <div v-for="(item,index) in fensi" :key="index" class="listItem">
                    <span class="triangle"></span><span class="name">{{item.name}}</span><span>{{item.value}}</span>
                  </div>
                </div> 
              </div>
            </div>
          </div>
          <div class="boxRight">
            <div class="title">直播人数</div>
            <div class="boxContent3">
              <div class="leftBg"><Right2Pie /></div>
              <div class="boxContent3Right">
                <div class="boxContent3RightTIt  animate__animated animate__slideInDown">
                  <div class="dqzbLeft"><span class="titIcon"><span></span></span><span class="font1">当前直播</span></div>
                  <span class="font2">25684<i>人</i></span>
                </div>
                <div class="listRight">
                  <div class="listRightItem animate__animated animate__zoomIn" v-for="(item,index) in zhiboRenqi" :key="index">
                    <div class="name">{{item.name}}</div>
                    <div class="value"><span>{{item.value}}</span>人</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import waterimg from "@/assets/img/xaiofei/fk.png"
const canvasContainer = ref(null);
let renderer, scene, camera, textureLoader, mesh;
let rotationSpeedX = 0.01;
let rotationSpeedY = 0.015;
let rotationSpeedZ = 0.03;

import RightLine from "../components/xaiofei/right1Line"
import Right2Pie from "../components/xaiofei/right2pie"
import centerRadar from "../components/xaiofei/centerRadar3"
import Map from "../components/xaiofei/map"
import { useRouter } from 'vue-router'
export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const timer = ref(null);
    const state = reactive({
      currentTime: "",
      isShow:true,
      zhibo:[
        {name:"淘宝",value:"63145.6",icon:require("/src/assets/img/xaiofei/tb.png")},
        {name:"抖音",value:"39952",icon:require("/src/assets/img/xaiofei/dy.png")}
      ],
      fensi:[{name:"粉丝",value:"1256"},{name:"新用户",value:"98%"}],
      zhiboRenqi:[{name:"男",value:"3000"},{name:"女",value:"3450"}]
  
    });
    onMounted(() => {
      init();
      animate();

    })
    onUnmounted(() => {
      // 清理资源
      renderer.dispose();
    });
    onBeforeUnmount(() => {
      clearInterval(timer.value);
    })
    // 返回上一页
    function clickReturn(){
        router.go(-1);
    }
    function close(){
      state.isShow=!state.isShow
    }
    // 旋转
    function init() {
      // 初始化渲染器
      renderer = new THREE.WebGLRenderer({ antialias: true , alpha: true });
      renderer.setClearColor(0x000000, 0); // 设置背景清除颜色为黑色但不透明度为0
      //renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true // 这允许renderer有透明通道 })
      renderer.setSize(canvasContainer.value.clientWidth, canvasContainer.value.clientHeight);
      canvasContainer.value.appendChild(renderer.domElement);

      // 初始化场景
      scene = new THREE.Scene();
      
      // 初始化相机
      camera = new THREE.PerspectiveCamera(110, 
        canvasContainer.value.clientWidth / canvasContainer.value.clientHeight, 
        1, 
        1000);
      // camera.position.z = 3;
      camera.position.set(0, 0, 1.3) //设置相机位置
      // camera.position.set(0, 0, 200); //设置相机位置
      camera.lookAt(scene.position) //设置相机方向(指向的场景对象)

      // 图片纹理加载器
      textureLoader = new THREE.TextureLoader();
      textureLoader.load(waterimg, (texture) => {
        // 创建一个平面几何体
        const geometry = new THREE.PlaneGeometry(2, 2);

        // 使用加载好的纹理创建材质
        const material = new THREE.MeshBasicMaterial({ map: texture ,transparent: true});

        // 创建并添加带有纹理的网格到场景中
        mesh = new THREE.Mesh(geometry, material);
        scene.add(mesh);
      var _s = 1.5
      _s += 0.01
      mesh.scale.set(_s, _s, _s)

      renderer.render(scene, camera) //执行渲染操作
      // requestAnimationFrame(render) //请求再次执行渲染函数render，渲染下一帧
      
      });
    }
    function animate() {
      requestAnimationFrame(animate);

      if (mesh) {
        // 每帧增加旋转角度
        // mesh.rotation.x += rotationSpeedX;
        // mesh.rotation.y += rotationSpeedY;
      // mesh.rotation.y += Math.PI;
        mesh.rotation.z += rotationSpeedZ; 

        // 如果需要限制旋转范围，可以使用下面的方法：
        // mesh.rotation.x = mesh.rotation.x % (1 * Math.PI);
        // mesh.rotation.y = mesh.rotation.y % (1 * Math.PI);
        // mesh.rotation.z = mesh.rotation.z % (1 * Math.PI);
      }

      renderer.render(scene, camera);
    }
    return {
      ...toRefs(state),
      close,
      canvasContainer,
      clickReturn
      
    };
  },
  components: {
      RightLine,
      Right2Pie,
      centerRadar,
      Map
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100%;
  background: url("../assets/img/xaiofei/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  .title0{
    width: 100%;
    height: 81px;
    background: url("../assets/img/xaiofei/bt.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 81px;
      height: 38px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 26px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
  }
  .content{
    width: 100%;
    height: calc(100% - 81px);
    display: flex;
    position: relative;
    .navBox{
      position: absolute;
      left: 0;
      top: 0;
      width: 320px;
      height: 100%;
      .navLeft{
        width: 320px;
        height: 100%;
        padding-right: 120px;
        display: flex;
        align-items: center;
        // justify-content: center;
        box-sizing: border-box;
        background: url("../assets/img/xaiofei/dh.png") no-repeat top center ;
        background-size: 100% 100%;
         position: relative;
         transition: all 1s ease-out;
        .leftLeft{ 
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          transition: all 1s ease-out;
          .btn{
            width: 147px;
            height: 53px;
            text-align: center;
            line-height: 53px;
            margin: 30px 0 0 0;
            font-size: 16px;
            cursor: pointer;
            transition: all 1s ease-out;
            animation: bianda 1s linear infinite;
            position: relative;
            span{
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;

            }
          }
          .btn1,.btn:hover{
            background: url("../assets/img/xaiofei/xz.png") no-repeat top center;
            color: #DBD600;
          }
          .btn2{
            background: url("../assets/img/xaiofei/wxz.png") no-repeat top center;
            color: #9FEFEE;
          }
          .btn:hover{
            position: relative;
            animation-play-state:paused;
            margin-bottom: 30px;
          }
        }
      .jiantou{
        width: 76px;
        height: 127px;
        position: absolute;
        right: 90px;
        animation: jiantou 1s linear infinite;
        cursor: pointer;
      }
      .jiantou1{
        transform: rotate(180deg);
      }
    }
    .left1{
      width: 160px;
      background: url("../assets/img/xaiofei/dh.png") no-repeat center right;
      transition: all 1s ease-out; 
    }
    .leftLeft1{
      width: 0;
      overflow: hidden;
      .btn{width: 0;}
    }
    }
    .leftBox{
      width: 320px;
      height: 100%;
    }
    
    .center{
      flex: 1;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      .centerBg1{
        width: 90%;
        height: 90%;
        background: url("../assets/img/xaiofei/yq.png") no-repeat;
        background-size: contain;
        background-position: center;
        animation: guangying 5s linear infinite;
      }
      .map{
        position: absolute;
        top: 5%;
        left: 5%;
        width: 90%;
        height: 90%;
        display: flex;
        justify-content: center;
        // img{
        //    width: 90%;
        //    height: auto;
        // }
      }
      
    }
    .right{
      width:462px ;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 50px;
      .boxRight{
        display: flex;
        flex-direction: column;
        .title{
          width: 100%;
          height: 46px;
          background: url("../assets/img/xaiofei/xbt.png") no-repeat;
          color: #9FEFEE;
          padding-left: 15px;
          font-weight: bold;
          font-size: 19px;
          box-sizing: border-box;
          font-weight: bold;
          text-align: left;
          line-height: 46px;
        }
        .boxContent1{
          width: 100%;
          flex: 1;
          background: url("../assets/img/xaiofei/dz.png") no-repeat;
          display: flex;
          .boxContent1Left{
            flex: 1;
            line-height: 30px;
            margin-top: 15px;
            .boxContent1LeftItem{
              text-align: left;
              padding: 10px 20px 0;
              .name{
                font-size: 15px;
                color: #B1EDED;
                img{
                margin-right: 10px;
                }
              }
              .value{
                font-size: 20px;
                color: #ffffff;
                font-weight: bold;
                padding-left: 20px;
              }
              
            }
          }
          .boxContent1Right{
            width:125px ;
            height: 132px;
            margin-right: 120px;
            // margin-top: 15px;
          }
        }
        .boxContent2{
          width: 100%;
          flex: 1;
          position: relative;
          .rightLine{
            width: 100%;
            height: 100%;
            
          }
          .leftContent{
            position: absolute;
            top: 10px;
            left: 0;
            width: 115px;
            height: 83px;
            background: url("../assets/img/xaiofei/zx.png") no-repeat;
            text-align: left;
            padding: 10px;
            box-sizing: border-box;
            line-height: 20px;
            h4{
              color: #B3F7F4;
              font-size: 15px;
            }
            .list{
              .listItem{
                display: flex;
              }
              .listItem .triangle{
                width: 7px;
                height: 7px;
                margin: 5px 5px 0 0;
                background-repeat: no-repeat;
                background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0) 50%, #fff 50%);
              }
              .listItem .name{
                color: #B3F7F4;
                font-size: 12px;
                // margin-right: 10px;
                width: 50px;
              }
            }
          }
        }
        .boxContent3{
          flex: 1;
          display: flex;
          padding-top: 20px;
          box-sizing: border-box;
          .leftBg{
            width: 60%;
            height: 100%;
            background: url("../assets/img/xaiofei/lg.png") no-repeat top center;
          }
          .boxContent3Right{
            margin:-20px 40px 0 -40px;
            flex: 1;
            line-height: 30px;
            .boxContent3RightTIt{
              display: flex;
              justify-content: space-between;
              span{
                display: block;
              }
              .dqzbLeft{
                display: flex;
                text-align: left;
                color: #B1EDED;
                .titIcon{
                width: 14px;
                height: 14px;
                border: 2px solid #8CFEFF;
                border-radius: 50%;
                padding: 2px;
                box-sizing: border-box;
                margin: 8px 5px;
                span{
                display: block;
                width: 100%;
                height: 100%;
                background: #8CFEFF;
                border-radius: 50%;
                }
              }
              .font1{
                font-size: 14px;
              }
              
              }
              .font2{
                font-size: 20px;
                color: #B1EDED;
                i{
                  font-size: 15px;
                }
              }
              
            }
            .listRight{
              margin-top: 10px;
              .listRightItem{
                background: #112932;
                margin-bottom: 10px;
                
                .name{
                  background: #23424B;
                  height: 22px;
                  line-height: 22px;
                  border-left: 2px solid #B1EDED;
                  border-right: 2px solid #B1EDED;
                  color: #B1EDED;
                  font-size: 14px;
                }
                .value{
                  height: 46px;
                  line-height: 46px;
                  border: 2px solid #112932;
                  display: flex;
                  justify-content: center;
                  span{
                    display: block;
                    font-size: 20px;
                    font-weight: bold;
                    margin-right: 5px;
                  }
                  
                }
              } 
              .listRightItem:nth-child(1){
                .value{
                  span{
                    color: #F9DE64;
                  }
                }
              }
              .listRightItem:nth-child(2){
                .value{
                  span{
                    color: #5CB2FA;
                  }
                }
              }
            }
          }
        }
      }
      .boxRight:nth-child(1){
        height: 258px;
      }
      .boxRight:nth-child(2){
        flex: 1;
      }
      .boxRight:nth-child(3){ 
        height: 260px;
      }
      
    }
    
  }
}
@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      // transform: scale(0.96);
      filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
   100%{
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      right: 90px;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    right: 95px;
  }
   100%{
    right: 90px;
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}
</style>
